import { WOW } from 'wowjs';

(() => {
    'use strict';

    new WOW({ live: false }).init();
})();